import Dropdown from 'lib/components/Dropdown/Dropdown'
import FilterDropdownTrigger from 'lib/components/FilterDropdownTrigger/FilterDropdownTrigger'
import { buildQueryString, QUERY_KEYS } from 'lib/util/routing'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import Series from '../Series'

export interface SeriesDropdownProps extends RouteComponentProps {
  selectedSeries?: Series
  series: Series[]
}

export default withRouter(function SeriesDropdown(props: SeriesDropdownProps) {
  const { location, selectedSeries, series: seriesList } = props
  const [t] = useTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const open = () => setIsOpen(true)
  const close = () => setIsOpen(false)

  const selectedSeriesName = !selectedSeries ? t('home.series.all.longName') : selectedSeries.title

  return (
    <Dropdown>
      <FilterDropdownTrigger onClick={open}>{selectedSeriesName}</FilterDropdownTrigger>
      {isOpen && (
        <Dropdown.Menu flip={true} placement="bottom-start" onRequestClose={close}>
          <Dropdown.MenuItem
            linkProps={{
              to: {
                search: buildQueryString(location, [[QUERY_KEYS.series]])
              }
            }}>
            {t('home.series.all.longName')}
          </Dropdown.MenuItem>
          {seriesList.map(series => (
            <Dropdown.MenuItem
              linkProps={{
                to: {
                  search: buildQueryString(location, [[QUERY_KEYS.series, series.title]])
                }
              }}
              key={series.id}>
              {series.title}
            </Dropdown.MenuItem>
          ))}
        </Dropdown.Menu>
      )}
    </Dropdown>
  )
})
